import { Component, OnDestroy, ViewChild } from '@angular/core';
import { NavController, NavParams, Platform
  , LoadingController
  , ToastController
  , VirtualScroll, Content } from 'ionic-angular';
import { MedlocResultsPage } from '../medloc-results/medloc-results';
import { Subscription }  from 'rxjs/Subscription';
import { DataProvider } from '../../providers/data/data';
import { InAppBrowser } from '@ionic-native/in-app-browser';

/**
 * Generated class for the MedicineStocklocPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-medicine-stockloc',
  templateUrl: 'medicine-stockloc.html',
})
export class MedicineStocklocPage implements OnDestroy {

  _data: any[] = [];
  list: any[] = [];
  cntItem: string;
  searchmessage: any;
  keytext: string;
  towncode: any;
  provcode: any;
  user: any;
  branchcode: any;

  private resetBackButton: any;

  blnLoc: boolean;

/*   _lat: any;
  _lon: any; */

/*   address: string;
  addressx: string; */


  searchItem: any;

  invmasSubs: Subscription;
  medLocSubs: Subscription;

  @ViewChild(Content) content: Content;
  @ViewChild('virtualList') virtualScroll: VirtualScroll;

  constructor(public navCtrl: NavController, public navParams: NavParams
    , private platform: Platform
    , private dataProv: DataProvider
    , private loadingCtrl: LoadingController
    , private toastCtrl: ToastController 
    , private iab: InAppBrowser
    ) {
  }

  ionViewDidLoad() {
  }

  getItems(ev: any) {
    let loadingx = this.loadingCtrl.create({
      content: 'Loading',
      enableBackdropDismiss: true
    });

    loadingx.present();

    if (this.searchItem != '') {
      if(this.searchItem.length > 2) {
          this._data = [];

          this.invmasSubs = this.dataProv.getInvmas00(this.searchItem, this.user, this.branchcode)
          .subscribe((rs: any[]) => {
            if(rs.length > 0) {
              this._data = rs;
              this.cntItem = this._data.length.toString() + ' item/s found matching the keyword.';  
              this.searchmessage = "";
            }
            else {
              let toastx = this.toastCtrl.create({
                message: 'No records found...',
                duration: 3000,
                position: 'bottom'
              });
              this.searchmessage = "No records found.";
              toastx.present();
            }
          }, error => {
            loadingx.dismiss();
            alert('Internet Connection: Please check if you have internet connection or too slow internet connection.');

          }, function() {
            loadingx.dismiss();
          });

      } else {
        loadingx.dismiss();

        let toast = this.toastCtrl.create({
          message: 'Input must be more than 2 character.',
          duration: 3000
        });
        toast.present();
      }
    } else {
      loadingx.dismiss();
      this.cntItem = '';
      return this._data.length = 0;
    }
  }

  prodInfo(drug: string) {
    let _drug = drug.substr(0, drug.indexOf(' '));
    this.iab.create('https://www.drugs.com/search.php?searchterm=' + _drug,'',{ location: 'no', hardwareback: 'yes' });
  }

  viewResults(code, desc) {
    this.navCtrl.push (MedlocResultsPage, { skuCode: code, skuDesc: desc, towncode: this.navParams.get('towncode'), provcode: this.navParams.get('provcode'), keyword: this.searchItem, user: this.user, branch: this.branchcode });
  }

  ionViewDidEnter() {
    this.keytext = this.navParams.get('keyword');
    this.towncode = this.navParams.get('towncode');
    this.provcode = this.navParams.get('provcode');
    this.user = this.navParams.get('user');
    this.branchcode = this.navParams.get('branch');
    this.searchItem = this.keytext;
    this.getItems(this.keytext);
  }

  ionViewWillLeave() {
    this.navParams.data.keyword = this.searchItem;
  }

  ngOnDestroy() {
    if(this.invmasSubs) {
      this.invmasSubs.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/medicine-stockloc/medicine-stockloc.ts